/**
 * @copyright Copyright (c) 2023 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
import logger from '../logger';
export class FileAction {
    _action;
    constructor(action) {
        this.validateAction(action);
        this._action = action;
    }
    get id() {
        return this._action.id;
    }
    get displayName() {
        return this._action.displayName;
    }
    get iconSvgInline() {
        return this._action.iconSvgInline;
    }
    get enabled() {
        return this._action.enabled;
    }
    get exec() {
        return this._action.exec;
    }
    get execBatch() {
        return this._action.execBatch;
    }
    get order() {
        return this._action.order;
    }
    get default() {
        return this._action.default;
    }
    get inline() {
        return this._action.inline;
    }
    get renderInline() {
        return this._action.renderInline;
    }
    validateAction(action) {
        if (!action.id || typeof action.id !== 'string') {
            throw new Error('Invalid id');
        }
        if (!action.displayName || typeof action.displayName !== 'function') {
            throw new Error('Invalid displayName function');
        }
        if (!action.iconSvgInline || typeof action.iconSvgInline !== 'function') {
            throw new Error('Invalid iconSvgInline function');
        }
        if (!action.exec || typeof action.exec !== 'function') {
            throw new Error('Invalid exec function');
        }
        // Optional properties --------------------------------------------
        if ('enabled' in action && typeof action.enabled !== 'function') {
            throw new Error('Invalid enabled function');
        }
        if ('execBatch' in action && typeof action.execBatch !== 'function') {
            throw new Error('Invalid execBatch function');
        }
        if ('order' in action && typeof action.order !== 'number') {
            throw new Error('Invalid order');
        }
        if ('default' in action && typeof action.default !== 'boolean') {
            throw new Error('Invalid default');
        }
        if ('inline' in action && typeof action.inline !== 'function') {
            throw new Error('Invalid inline function');
        }
        if ('renderInline' in action && typeof action.renderInline !== 'function') {
            throw new Error('Invalid renderInline function');
        }
    }
}
export const registerFileAction = function (action) {
    if (typeof window._nc_fileactions === 'undefined') {
        window._nc_fileactions = [];
        logger.debug('FileActions initialized');
    }
    // Check duplicates
    if (window._nc_fileactions.find(search => search.id === action.id)) {
        logger.error(`FileAction ${action.id} already registered`, { action });
        return;
    }
    window._nc_fileactions.push(action);
};
export const getFileActions = function () {
    return window._nc_fileactions || [];
};
